import Header from '~/Components/Header/Header';
import React, { useCallback, useEffect, useState } from 'react';
import {
  Form,
  Button,
  Card,
  Row,
  Col,
  InputGroup,
  Badge,
  Modal,
  Alert,
} from 'react-bootstrap';
import { Formik } from 'formik';
import Select from 'react-select';
import DateMask from '~/Components/DateMask';
import MaskedInput from 'react-text-mask';
import * as constants from '~/constant';
import { caracteristicas } from '~/constant';
import AuthStorage from '~/Utils/AuthStorage';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { FaSearch, FaLock, FaBan, FaSpinner, FaExclamationTriangle, FaCheck } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import * as api from '~/Services/Service';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Loading from '~/Components/Loading';
import { FaSortUp, FaSortDown } from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';

import ModalStatusDoc from '~/Components/SolicitacoesCessoes/ModalStatusDoc';
import ModalDetalhes from '~/Components/SolicitacoesCessoes/ModalDetalhes';
import {
  ETAPAS_OPTIONS,
  SUBETAPAS_OPTIONS,
  STATUS_SOLICITACAO_OPTIONS,
  formatCpfCnpj,
} from '~/Components/SolicitacoesCessoes/constants';
import ModalBoleto from '~/Components/SolicitacoesCessoes/ModalBoleto';

export default function SolicitacoesCessoes() {
  const podeCancelar = AuthStorage.temCaracteristica(caracteristicas.CancelarSolicitacaoCessao);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: 'data_inclusao',
    direction: 'desc',
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showBoletoModal, setShowBoletoModal] = useState(false);
  const [showCancelarModal, setShowCancelarModal] = useState(false);
  const [observacaoCancelamento, setObservacaoCancelamento] = useState('');
  const [cancelando, setCancelando] = useState(false);
  const [lastFilters, setLastFilters] = useState(null);

  const empreendimentos = useSelector(state => state.empreendimentos);
  const optionsEmpreendimentos = [
    ...empreendimentos.sort.map(item => ({
      value: item.codigo,
      label: item.codigo + ' - ' + item.descricao,
    })),
  ];

  const [cidadesOpts, setCidadesOpts] = useState([]);

  const buscarCidades = useCallback(async () => {
    try {
      const response = await api.getCities();
      const opts = response.map(item => ({
        value: item.codigo,
        label: item.cidade,
      }));
      setCidadesOpts(opts);
    } catch (err) {
      setCidadesOpts([]);
    }
  }, []);

  useEffect(() => {
    buscarCidades();
    api.processarInativacaoCessao().catch(() => {});
  }, [buscarCidades]);

  const buscarSolicitacoes = useCallback(async filtros => {
    setIsLoading(true);
    setError(null);
    try {
      const params = {
        codigo_cidade: filtros.cidade_codigo || undefined,
        codigo_familia: filtros.empreendimento_codigo || undefined,
        cliente: filtros.cliente_query || undefined,
        data_inicial: filtros.data_inicial || undefined,
        data_final: filtros.data_final || undefined,
        codigo_etapa: filtros.etapa_atual || undefined,
        codigo_sub_etapa: filtros.status || undefined,
        status: filtros.status_solicitacao !== '' ? filtros.status_solicitacao : undefined,
      };
      const data = await api.listarSolicitacoesCessao(params);
      setSolicitacoes(data || []);
      setLastFilters(filtros);
    } catch (err) {
      setError('Erro ao buscar solicitações');
      setSolicitacoes([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const recarregarSolicitacoes = useCallback(() => {
    if (lastFilters) {
      buscarSolicitacoes(lastFilters);
    }
  }, [lastFilters, buscarSolicitacoes]);

  const sortedSolicitacoes = React.useMemo(() => {
    if (!solicitacoes || solicitacoes.length === 0) return [];
    const sorted = [...solicitacoes].sort((a, b) => {
      var av = a[sortConfig.key];
      var bv = b[sortConfig.key];
      if (sortConfig.key === 'data_inclusao') {
        var pa = new Date(av);
        var pb = new Date(bv);
        return sortConfig.direction === 'asc' ? pa - pb : pb - pa;
      }
      var na = parseFloat(av);
      var nb = parseFloat(bv);
      if (!isNaN(na) && !isNaN(nb))
        return sortConfig.direction === 'asc' ? na - nb : nb - na;
      var sa = String(av || '').toLowerCase();
      var sb = String(bv || '').toLowerCase();
      if (sa < sb) return sortConfig.direction === 'asc' ? -1 : 1;
      if (sa > sb) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [solicitacoes, sortConfig]);

  const handleSort = key => {
    setSortConfig(prev => ({
      key: key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getSortIcon = key => {
    var isActive = sortConfig.key === key;
    if (!isActive || sortConfig.direction === 'desc')
      return <FaSortUp size={12} />;
    return <FaSortDown size={12} />;
  };

  const formatDate = dateValue => {
    if (!dateValue) return '-';
    return moment(dateValue).format('DD/MM/YYYY');
  };

  const handleOpenDetail = item => {
    setSelectedRow(item);
    setShowDetailModal(true);
  };

  const handleOpenStatusModal = item => {
    setSelectedRow(item);
    setShowStatusModal(true);
  };

  const handleOpenBoletoModal = item => {
    setSelectedRow(item);
    setShowBoletoModal(true);
  };

  const handleOpenCancelarModal = item => {
    setSelectedRow(item);
    setObservacaoCancelamento('');
    setShowCancelarModal(true);
  };

  const handleConfirmarCancelamento = async () => {
    if (!selectedRow) return;
    setCancelando(true);
    try {
      await api.cancelarSolicitacaoCessao({
        codigo_solicitacao: selectedRow.codigo,
        observacao: observacaoCancelamento,
      });
      toast.success('Solicitação cancelada com sucesso.');
      setShowCancelarModal(false);
      recarregarSolicitacoes();
    } catch (err) {
      toast.error(err && err.message ? err.message : 'Não foi possível cancelar a solicitação.');
    } finally {
      setCancelando(false);
    }
  };

  return (
    <>
      <Header title={'Solicitações de Cessões'} />
      <div className="container-fluid">
        <div className="CardProdutividadeFiltro">
          <Card>
            <Card.Body>
              <Formik
                onSubmit={values => buscarSolicitacoes(values)}
                initialValues={{
                  cidade_codigo: '',
                  empreendimento_codigo: '',
                  cliente_query: '',
                  data_inicial: '',
                  data_final: '',
                  etapa_atual: '',
                  status: '',
                  status_solicitacao: '',
                }}
              >
                {({
                  handleSubmit,
                  values,
                  setFieldValue,
                  handleChange,
                  resetForm,
                  errors,
                  touched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Row className="align-items-end">
                      <Col xs="12" md="3">
                        <Form.Group controlId="search.cidade">
                          <Form.Label>Cidade</Form.Label>
                          <Select
                            placeholder={
                              !cidadesOpts.length ? 'Carregando...' : 'Todos...'
                            }
                            isDisabled={!cidadesOpts.length || isLoading}
                            isClearable
                            options={cidadesOpts}
                            value={
                              cidadesOpts.find(
                                opt => opt.value == values.cidade_codigo
                              ) || null
                            }
                            onChange={option =>
                              setFieldValue(
                                'cidade_codigo',
                                option ? option.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group controlId="search.empreendimento">
                          <Form.Label>Empreendimento</Form.Label>
                          <Select
                            placeholder={
                              !optionsEmpreendimentos.length
                                ? 'Carregando...'
                                : 'Todos...'
                            }
                            isDisabled={
                              !optionsEmpreendimentos.length || isLoading
                            }
                            isClearable
                            options={optionsEmpreendimentos}
                            value={
                              optionsEmpreendimentos.find(
                                opt => opt.value == values.empreendimento_codigo
                              ) || null
                            }
                            onChange={selectedOption =>
                              setFieldValue(
                                'empreendimento_codigo',
                                selectedOption ? selectedOption.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="4">
                        <Form.Group controlId="search.cliente">
                          <Form.Label>Cliente</Form.Label>
                          <Form.Control
                            name="cliente_query"
                            type="text"
                            placeholder="Buscar por nome ou CPF/CNPJ"
                            value={values.cliente_query}
                            onChange={handleChange}
                            disabled={isLoading}
                            className={`form-control ${errors.cliente_query &&
                              touched.cliente_query &&
                              'is-invalid'}`}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.cliente_query}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Group controlId="search.status_solicitacao">
                          <Form.Label>Situação</Form.Label>
                          <Select
                            placeholder="Todos"
                            isClearable
                            isDisabled={isLoading}
                            options={STATUS_SOLICITACAO_OPTIONS}
                            value={
                              STATUS_SOLICITACAO_OPTIONS.find(
                                o => o.value === values.status_solicitacao
                              ) || null
                            }
                            onChange={option =>
                              setFieldValue(
                                'status_solicitacao',
                                option ? option.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="align-items-end">
                      <Col xs="12" md="4">
                        <Form.Label>Período Solicitação</Form.Label>
                        <InputGroup>
                          <div>
                            <DateMask
                              initialValue={values.data_inicial}
                              allowEmpty
                              onValidate={value =>
                                setFieldValue('data_inicial', value)
                              }
                            >
                              {({ dateError, dateValue, setDate }) => (
                                <Form.Group controlId="search.data_inicial">
                                  <MaskedInput
                                    name="data_inicial"
                                    type="tel"
                                    required={false}
                                    guide={false}
                                    disabled={isLoading}
                                    className={`form-control ${((errors.data_inicial &&
                                      touched.data_inicial) ||
                                      dateError) &&
                                      'is-invalid'}`}
                                    placeholder="Ex.: 01/01/2025"
                                    mask={constants.MASK_DATE}
                                    value={dateValue}
                                    onChange={e => setDate(e.target.value)}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.data_inicial}
                                  </Form.Control.Feedback>
                                  <Form.Control.Feedback type="invalid">
                                    {dateError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}
                            </DateMask>
                          </div>
                          <div className="text-center px-0">
                            <span
                              className="input-group-text"
                            >
                              a
                            </span>
                          </div>
                          <div>
                            <DateMask
                              initialValue={values.data_final}
                              allowEmpty
                              onValidate={value =>
                                setFieldValue('data_final', value)
                              }
                            >
                              {({ dateError, dateValue, setDate }) => (
                                <Form.Group controlId="search.data_final">
                                  <MaskedInput
                                    name="data_final"
                                    type="tel"
                                    required={false}
                                    guide={false}
                                    disabled={isLoading}
                                    className={`form-control ${((errors.data_final &&
                                      touched.data_final) ||
                                      dateError) &&
                                      'is-invalid'}`}
                                    placeholder="Ex.: 01/01/2025"
                                    mask={constants.MASK_DATE}
                                    value={dateValue}
                                    onChange={e => setDate(e.target.value)}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.data_final}
                                  </Form.Control.Feedback>
                                  <Form.Control.Feedback type="invalid">
                                    {dateError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}
                            </DateMask>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col xs="12" md="4">
                        <Form.Group controlId="search.etapa_atual">
                          <Form.Label>Etapa Atual</Form.Label>
                          <Select
                            placeholder="Todos"
                            isClearable
                            isDisabled={isLoading}
                            options={ETAPAS_OPTIONS}
                            value={
                              ETAPAS_OPTIONS.find(
                                o => o.value === values.etapa_atual
                              ) || null
                            }
                            onChange={option =>
                              setFieldValue(
                                'etapa_atual',
                                option ? option.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="4">
                        <Form.Group controlId="search.status">
                          <Form.Label>Status da Etapa</Form.Label>
                          <Select
                            placeholder="Todos"
                            isClearable
                            isDisabled={isLoading}
                            options={SUBETAPAS_OPTIONS}
                            value={
                              SUBETAPAS_OPTIONS.find(
                                o => o.value === values.status
                              ) || null
                            }
                            onChange={option =>
                              setFieldValue(
                                'status',
                                option ? option.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="justify-content-end">
                      <Col xs="12" lg="auto" className="text-right">
                        <Form.Group>
                          <Button
                            disabled={
                              !cidadesOpts.length ||
                              !optionsEmpreendimentos.length ||
                              isLoading
                            }
                            variant="success"
                            type="submit"
                            className="ml-2"
                          >
                            {isLoading ? (
                              <>
                                <FaSpinner className="fa-spin" />
                                <span>&nbsp;Buscando...</span>
                              </>
                            ) : (
                              <>
                                <FaSearch />
                                <span>&nbsp;Buscar</span>
                              </>
                            )}
                          </Button>
                          <Button
                            variant="outline-secondary"
                            className="ml-2"
                            disabled={isLoading}
                            onClick={() => {
                              resetForm();
                              setSolicitacoes([]);
                              setLastFilters(null);
                            }}
                          >
                            Limpar Filtros
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>
                  </form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </div>
        <Row className="p-4">
          {error ? (
            <Col className="text-center">
              <div className="alert alert-danger">{error}</div>
            </Col>
          ) : isLoading ? (
            <Col className="text-center">
              <Loading />
            </Col>
          ) : solicitacoes.length > 0 ? (
            <Col xs={12} className="bg-white table-responsive">
              <Table className="table table-striped table-bordered table-hover p-3">
                <Thead>
                  <Tr className="text-center font-size-14">
                    <Th
                      onClick={() => handleSort('data_inclusao')}
                      style={{ cursor: 'pointer' }}
                    >
                      Data {getSortIcon('data_inclusao')}
                    </Th>
                    <Th
                      onClick={() => handleSort('etapa')}
                      style={{ cursor: 'pointer' }}
                    >
                      Etapa Atual {getSortIcon('etapa')}
                    </Th>
                    <Th
                      onClick={() => handleSort('sub_etapa')}
                      style={{ cursor: 'pointer' }}
                    >
                      Status da Etapa {getSortIcon('sub_etapa')}
                    </Th>
                    <Th
                      onClick={() => handleSort('nome_solicitante')}
                      style={{ cursor: 'pointer' }}
                    >
                      Solicitante {getSortIcon('nome_solicitante')}
                    </Th>
                    <Th
                      onClick={() => handleSort('ge')}
                      style={{ cursor: 'pointer' }}
                    >
                      GE {getSortIcon('ge')}
                    </Th>
                    <Th
                      onClick={() => handleSort('cidade')}
                      style={{ cursor: 'pointer' }}
                    >
                      Cidade {getSortIcon('cidade')}
                    </Th>
                    <Th
                      onClick={() => handleSort('empreendimento')}
                      style={{ cursor: 'pointer' }}
                    >
                      Empreendimento {getSortIcon('empreendimento')}
                    </Th>
                    <Th
                      onClick={() => handleSort('quadra')}
                      style={{ cursor: 'pointer' }}
                    >
                      Quadra {getSortIcon('quadra')}
                    </Th>
                    <Th
                      onClick={() => handleSort('lote')}
                      style={{ cursor: 'pointer' }}
                    >
                      Lote {getSortIcon('lote')}
                    </Th>
                    <Th
                      onClick={() => handleSort('tipo_cessao')}
                      style={{ cursor: 'pointer' }}
                    >
                      Tipo da Cessão {getSortIcon('tipo_cessao')}
                    </Th>
                    <Th
                      onClick={() => handleSort('cpf_cnpj')}
                      style={{ cursor: 'pointer' }}
                    >
                      CPF/CNPJ {getSortIcon('cpf_cnpj')}
                    </Th>
                    <Th
                      onClick={() => handleSort('especialista')}
                      style={{ cursor: 'pointer' }}
                    >
                      Especialista {getSortIcon('especialista')}
                    </Th>
                    <Th
                      onClick={() => handleSort('perfil_cliente')}
                      style={{ cursor: 'pointer' }}
                    >
                      Perfil Cliente {getSortIcon('perfil_cliente')}
                    </Th>
                    <Th>Detalhes</Th>
                    <Th>Status Doc.</Th>
                    <Th>Gerar Boleto</Th>
                    {podeCancelar && <Th>Cancelar</Th>}
                  </Tr>
                </Thead>
                <Tbody className="text-center font-size-13">
                  {sortedSolicitacoes.map((item, idx) => {
                    const inativa = item.status === 0;
                    return (
                    <Tr key={item.codigo || idx} className={inativa ? 'table-secondary' : ''}>
                      <Td>
                        {formatDate(item.data_inclusao)}
                        {inativa && (
                          <div>
                            <Badge variant="danger" title="Solicitação Inativa">
                              <FaBan size={10} className="mr-1" />
                              Inativa
                            </Badge>
                          </div>
                        )}
                      </Td>
                      <Td>{item.etapa}</Td>
                      <Td>
                        <span className="d-flex align-items-center justify-content-center">
                          {item.sub_etapa}
                          {item.bloqueado && (
                            <Badge
                              variant="danger"
                              className="ml-2"
                              title="Solicitação Bloqueada"
                            >
                              <FaLock size={10} />
                            </Badge>
                          )}
                        </span>
                      </Td>
                      <Td>
                        {item.codigo_conta} - {item.nome_solicitante}
                      </Td>
                      <Td>{item.ge}</Td>
                      <Td>{item.cidade}</Td>
                      <Td>
                        {item.codigo_familia} - {item.empreendimento}
                      </Td>
                      <Td>{item.quadra}</Td>
                      <Td>{item.lote}</Td>
                      <Td>{item.tipo_cessao}</Td>
                      <Td>{formatCpfCnpj(item.cpf_cnpj)}</Td>
                      <Td>{item.especialista || '-'}</Td>
                      <Td>{item.perfil_cliente || '-'}</Td>
                      <Td>
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => handleOpenDetail(item)}
                          title={'Ver detalhes'}
                        >
                          <FaSearch color={'#0747a6'} size={18} />
                        </Button>
                      </Td>
                      <Td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          disabled={inativa || item.codigo_etapa !== 2}
                          title={
                            inativa
                              ? 'Solicitação inativa'
                              : item.codigo_etapa !== 2
                                ? 'Disponível apenas na etapa de Análise de Documentos'
                                : 'Alterar status da documentação'
                          }
                          onClick={() => {
                            if (!inativa && item.codigo_etapa === 2) {
                              handleOpenStatusModal(item);
                            }
                          }}
                        >
                          Status Doc.
                        </Button>
                      </Td>
                      <Td>
                        <Button
                          variant="outline-success"
                          size="sm"
                          disabled={inativa || item.codigo_etapa !== 3}
                          title={
                            inativa
                              ? 'Solicitação inativa'
                              : item.codigo_etapa !== 3
                                ? 'Disponível apenas na etapa de Pagamento'
                                : 'Gerar boleto da taxa de transferência'
                          }
                          onClick={() => {
                            if (!inativa && item.codigo_etapa === 3) {
                              handleOpenBoletoModal(item);
                            }
                          }}
                        >
                          Gerar Boleto
                        </Button>
                      </Td>
                      {podeCancelar && (
                        <Td>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            disabled={inativa}
                            title={inativa ? 'Solicitação já está inativa' : 'Cancelar solicitação'}
                            onClick={() => {
                              if (!inativa) handleOpenCancelarModal(item);
                            }}
                          >
                            <FaBan className="mr-1" />
                            Cancelar
                          </Button>
                        </Td>
                      )}
                    </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </Col>
          ) : lastFilters ? (
            <Col className="text-center">
              <p className="text-muted">Nenhuma solicitação encontrada</p>
            </Col>
          ) : (
            <Col className="text-center">
              <p className="text-muted">
                Utilize os filtros acima para buscar solicitações
              </p>
            </Col>
          )}
        </Row>
      </div>

      <ModalStatusDoc
        show={showStatusModal}
        onHide={() => setShowStatusModal(false)}
        solicitacao={selectedRow}
        onSuccess={recarregarSolicitacoes}
      />

      <ModalDetalhes
        show={showDetailModal}
        onHide={() => setShowDetailModal(false)}
        solicitacao={selectedRow}
        onStatusChange={abrirModalStatus => {
          setShowDetailModal(false);
          if (abrirModalStatus) {
            handleOpenStatusModal(selectedRow);
          }
        }}
        onSuccess={recarregarSolicitacoes}
      />

      <ModalBoleto
        show={showBoletoModal}
        onHide={() => setShowBoletoModal(false)}
        solicitacao={selectedRow}
        onSuccess={recarregarSolicitacoes}
      />

      <Modal
        show={showCancelarModal}
        onHide={() => !cancelando && setShowCancelarModal(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title>
            <FaBan className="mr-2" />
            Cancelar Solicitação
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Você está prestes a cancelar a solicitação
            {selectedRow ? ` #${selectedRow.codigo}` : ''} de
            {selectedRow ? ` ${selectedRow.nome_solicitante}` : ''}.
          </p>
          <Form.Group controlId="cancelar.observacao">
            <Form.Label>Observação (opcional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              maxLength={500}
              value={observacaoCancelamento}
              onChange={e => setObservacaoCancelamento(e.target.value)}
              disabled={cancelando}
              placeholder="Motivo do cancelamento"
            />
          </Form.Group>
          <Alert variant="warning" className="mb-0">
            <FaExclamationTriangle className="mr-2" />
            <strong>Atenção:</strong> a solicitação será marcada como inativa e
            não poderá ser reativada por esta tela.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            disabled={cancelando}
            onClick={() => setShowCancelarModal(false)}
          >
            Voltar
          </Button>
          <Button
            variant="danger"
            disabled={cancelando}
            onClick={handleConfirmarCancelamento}
          >
            {cancelando ? (
              <>
                <FaSpinner className="fa-spin mr-2" />
                Cancelando...
              </>
            ) : (
              <>
                <FaCheck className="mr-2" />
                Confirmar Cancelamento
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
